import { schema } from 'normalizr';

export const roleSchema = new schema.Entity('roles', {}, { idAttribute: '_id' });
export const roleListSchema = [roleSchema];
